import { render, staticRenderFns } from "./OpenLayers.vue?vue&type=template&id=2d2bec4f"
import script from "./OpenLayers.vue?vue&type=script&lang=js"
export * from "./OpenLayers.vue?vue&type=script&lang=js"
import style0 from "./OpenLayers.vue?vue&type=style&index=0&id=2d2bec4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports